export default function Loader() {
  return (
    <div
      className="fixed inset-0 z-[9999] grid place-items-center bg-gray-800"
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div
        className="
          h-16 w-16 rounded-full
          border-[5px] border-purple-700
          border-t-white
          animate-[spin_5s_linear_infinite] motion-reduce:animate-none
        "
      />
      <span className="sr-only">Loading</span>
    </div>
  );
}
